import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'

export function createTrackConfig() {
  return {
    poizon_venue_component_content_click(platform: string, dataset: any) {
      if (platform !== 'sensors') return
      if (this.isBtnMsgGoUse) {
        return {
          current_page: 82,
          block_type: 660,
          poizon_channel_id,
          venue_id: this.props.editConfig.id,
          venue_title: document.title,
          poizon_component_type: 'poizon-new-user-coupon',
          SK: window.dw.getSk(),
        }
      }
    },
    poizon_venue_component_content_exposure(platform: string, dataset: any) {
      if (platform !== 'sensors') return

      return {
        current_page: 82,
        block_type: 660,
        poizon_channel_id,
        venue_id: this.props.editConfig.id,
        venue_title: document.title,
        poizon_component_type: 'poizon-new-user-coupon',
        SK: window.dw.getSk(),
      }
    },
  } as any
}
